export default __webpack_public_path__ + "static/media/Guru-Parampara-29.29881a08.png";